import 'core-js/actual/array/find-last';
import { createApp } from 'vue';
import App from './App.vue';
import router from './router'; // Import the router
import i18n from './i18n';
import { createPinia } from 'pinia';
import * as Sentry from "@sentry/vue";


import './assets/main.css';
import './assets/theme.css';
import './lib/materialWeb.js';

const app = createApp(App);

Sentry.init({
    app,
    dsn: import.meta.env.VITE_SENTRY_DSN,
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true
});

const pinia = createPinia();
app.use(pinia);
// Router and i18n initialization
app.use(router); // Use the router
app.use(i18n);
app.mount('#app');

